import { useState } from 'react'
import styled from 'styled-components'
import { type InputChangeEvent } from '@/features/shared/utils/dataFetching/types'
import { Button } from '@shipt/design-system-buttons'
import { TextInput } from '@shipt/design-system-inputs'
import { AddressIcon } from '@shipt/design-system-icons'

type Props = {
  isLoading: boolean
  onUpdateZipSubmit: (zipcode: string) => void
}

export const UpdateZipForm = ({ isLoading = false, onUpdateZipSubmit }: Props) => {
  const [zipcode, setZipcode] = useState('')

  const handleSubmit = (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault()
    onUpdateZipSubmit(zipcode)
  }

  const handleChange = (e: InputChangeEvent) => {
    const value = e.target.value.slice(0, 5)
    setZipcode(value)
  }

  return (
    <form onSubmit={handleSubmit}>
      <ZipFormFieldset>
        <InputContainer>
          <InputWrapper
            id="zipcode"
            name="zipcode"
            placeholder="Enter ZIP code"
            onChange={handleChange}
            value={zipcode}
            type="number"
            leading={<AddressIcon />}
          />
        </InputContainer>
        <Button type="submit" disabled={zipcode.length !== 5} loading={isLoading} fullWidth>
          Find stores near you
        </Button>
      </ZipFormFieldset>
    </form>
  )
}

const ZipFormFieldset = styled.fieldset`
  border-width: 0;
  margin: 0;
  padding: 0;
`
const InputContainer = styled.div`
  margin-bottom: 0.5rem;
`
const InputWrapper = styled(TextInput)`
  /* We need this so that Input with type number can hide the arrows associated with it */

  /* Google Chrome, Safari, Edge */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    appearance: textfield;
  }
`
